import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const CurrenciesQuery = gql`
  query {
    currencies {
      id
      value
      primary
      exchangeRate
      hasPurchasePrice
    }
    languages {
      id
      value
    }
  }
`;

const CreateCurrencyMutation = gql`
  mutation($currency: CurrencyInput!) {
    createCurrency(currency: $currency) {
      id
    }
  }
`;

const UpdateCurrencyMutation = gql`
  mutation($id: String!, $currency: CurrencyInput!) {
    updateCurrency(id: $id, currency: $currency) {
      id
    }
  }
`;

const DeleteCurrencyMutation = gql`
  mutation($id: String!) {
    deleteCurrency(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetCurrenciesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { currencies, createCurrency, updateCurrency, deleteCurrency }: any = this.props;

    const primaryCurrency = currencies && currencies.currencies
      ? currencies.currencies.find((c: GQL.ICurrency) => c.primary === true)
      : undefined;

    return this.props.children({ currencies, primaryCurrency, createCurrency, updateCurrency, deleteCurrency });
  }
}

export default compose(
  graphql<IInputProps, Response>(CurrenciesQuery, {
    name: 'currencies'
  }),
  graphql<IInputProps, Response>(CreateCurrencyMutation, {
    name: 'createCurrency'
  }),
  graphql<IInputProps, Response>(UpdateCurrencyMutation, {
    name: 'updateCurrency'
  }),
  graphql<IInputProps, Response>(DeleteCurrencyMutation, {
    name: 'deleteCurrency'
  })
)(GetCurrenciesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Currencies/Currencies.tsx